import syncRouterWithViewer from '../syncRouterWithViewer';
import syncDocumentHeightWithViewer from '../syncDocumentHeightWithViewer';

function initTPAViewModeSite() {
  syncRouterWithViewer();
  syncDocumentHeightWithViewer();
}

export default initTPAViewModeSite;
